/**
 * 控件类型配置
 * @type {[{component: string, label: string, attribute: null, value: string},{component: string, label: string, attribute: string, value: string},{component: string, label: string, attribute: {component: string, type: string}, value: string},{component: string, label: string, value: string},{component: string, label: string, value: string},null,null,null,null,null,null,null,null,null,null,null]}
 */
export const controlType = [
  {label: '文本', value: 'label', component: 'easydata-label', attribute: 'ed-label'},
  {label: '超链接', value: 'link', component: 'easydata-link', attribute: 'ed-link'},
  {label: '单行输入框', value: 'input', component: 'easydata-input', attribute: 'el-input'},
  {label: '多行输入框', value: 'textarea', component: 'easydata-textarea', attribute: 'el-input'},
  {label: '数字输入框', value: 'inputNumber', component: 'easydata-inputNumber', attribute: 'el-input-number'},
  {label: '单选框', value: 'radio', component: 'easydata-radio', attribute: 'el-radio-group'},
  {label: '多选框', value: 'checkbox', component: 'easydata-checkbox', attribute: 'el-checkbox-group'},
  {label: '开关', value: '_switch', component: 'easydata-switch', attribute: 'el-switch'},
  {label: '时间选择框', value: 'timeSelect', component: 'easydata-timeSelect', attribute: 'el-time-select'},
  {label: '日期选择框', value: 'datePicker', component: 'easydata-datePicker', attribute: 'el-date-picker'},
  {label: '下拉框', value: 'select', component: 'easydata-select', attribute: 'el-select'},
  {label: '级联下拉', value: 'cascader', component: 'easydata-cascader', attribute: 'el-cascader'},
  {label: '选择弹窗', value: 'popup', component: 'easydata-popup', attribute: 'el-input'},
  {label: '文件上传', value: 'upload', component: 'easydata-upload', attribute: 'ed-upload'},
  {label: '图片轮播', value: 'imgPreview', component: 'easydata-imgPreview'},
  {label: '联动公式', value: 'expression', component: 'easydata-expression', attribute: 'el-input'},
  {label: '富文本', value: 'editor', component: 'easydata-editor', attribute: 'ed-wang-editor'},
]


